import * as ActionTypes from '../actions/types/UserExperimentActionTypes';

const initialState = {
  busy: false,
  experiments: {},
};

const userExperimentReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_VARIATIONID: {
      return Object.assign({}, state, { busy: true });
    }
    case ActionTypes.RECEIVE_VARIATIONID: {
      if (!action.payload) return Object.assign({}, state, { busy: false });
      const { data } = action.payload;
      const experimentId = data.experiment_id;
      const variationId = data.variation_id;
      const experimentObj = {};
      experimentObj[experimentId] = { experimentId, variationId };
      const updatedExperimentsObj = Object.assign(state.experiments, experimentObj);

      return Object.assign({}, state, {
        experiments: updatedExperimentsObj,
        busy: false,
      });
    }
    default:
      return state;
  }
};

export default userExperimentReducer;



// WEBPACK FOOTER //
// ./src/reducers/userExperiment.js